<footer class="main-footer">
  <div class="container footer-grid">
    <!-- Brand Info -->
    <div class="footer-col brand-col">
      <div class="footer-logo">
        <span class="logo-icon">🔱</span> Kashi Vedic Sewa
      </div>
      <p class="brand-desc">
        India's most trusted online platform for authentic Hindu rituals and Vedic pujas. We connect you directly with highly qualified, experienced shastri scholars of Varanasi (Kashi) for offline and online pujas.
      </p>
      <div class="social-links">
        <a href="#" aria-label="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
        <a href="#" aria-label="Instagram"><i class="fa-brands fa-instagram"></i></a>
        <a href="#" aria-label="YouTube"><i class="fa-brands fa-youtube"></i></a>
        <a href="#" aria-label="Twitter"><i class="fa-brands fa-twitter"></i></a>
      </div>
    </div>

    <!-- Navigation Directory -->
    <div class="footer-col">
      <h3>Quick Links</h3>
      <ul class="footer-links">
        <li><a routerLink="/"><i class="fa-solid fa-angle-right"></i> Home</a></li>
        <li><a routerLink="/pujas"><i class="fa-solid fa-angle-right"></i> Browse Pujas</a></li>
        <li><a routerLink="/about"><i class="fa-solid fa-angle-right"></i> Our Heritage</a></li>
        <li><a routerLink="/contact"><i class="fa-solid fa-angle-right"></i> Contact Us</a></li>
        <li><a routerLink="/cart"><i class="fa-solid fa-angle-right"></i> Checkout Cart</a></li>
      </ul>
    </div>

    <!-- Categories Directory -->
    <div class="footer-col">
      <h3>Popular Categories</h3>
      <ul class="footer-links">
        <li><a routerLink="/pujas"><i class="fa-solid fa-angle-right"></i> Temple Specific Pujas</a></li>
        <li><a routerLink="/pujas"><i class="fa-solid fa-angle-right"></i> Dosh Nirvan Pujas</a></li>
        <li><a routerLink="/pujas"><i class="fa-solid fa-angle-right"></i> Puja at Home</a></li>
        <li><a routerLink="/pujas"><i class="fa-solid fa-angle-right"></i> Dugdhabhishek Services</a></li>
      </ul>
    </div>

    <!-- Contact Info -->
    <div class="footer-col contact-col">
      <h3>Office &amp; Sansthan</h3>
      <ul class="contact-details">
        <li>
          <i class="fa-solid fa-location-dot"></i>
          <div>D47, 195B, Girja Ghar Chauraha, Maulvibagh, Ramapura Luxa Thana, Varanasi, UP 221010</div>
        </li>
        <li>
          <i class="fa-solid fa-phone"></i>
          <div><a href="tel:+919999999999">+91 99999 99999</a></div>
        </li>
        <li>
          <i class="fa-solid fa-envelope"></i>
          <div><a href="mailto:info@kashivedicsewa.com">info&#64;kashivedicsewa.com</a></div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Bottom Footer -->
  <div class="bottom-footer">
    <div class="container d-flex justify-content-between align-items-center d-flex-mobile-col gap-2">
      <div class="copy-text">
        &copy; {{ currentYear }} Kashi Vedic Sewa. All rights reserved.
      </div>
      <div class="payment-badges d-flex gap-2">
        <span class="pay-badge" title="Visa Card"><i class="fa-brands fa-cc-visa"></i></span>
        <span class="pay-badge" title="Mastercard"><i class="fa-brands fa-cc-mastercard"></i></span>
        <span class="pay-badge" title="UPI Payment"><i class="fa-solid fa-qrcode"></i></span>
        <span class="pay-badge" title="PayPal secure"><i class="fa-brands fa-cc-paypal"></i></span>
      </div>
    </div>
  </div>
</footer>
